import { FolderContinuousRecordWidgetStore } from './folder-continuous-record-widget.store';
import { translate } from '../../../../modules/shared/shared.global-service';
import { Component, effect, inject, input } from '@angular/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { getWorkFrag } from './folder-continuous-record-widget.query';
import { SafeHtmlPipe } from '../../../../modules/shared/pipes/safe-html.pipe';
import {
    ContinuousRecordCreateDialogComponent,
} from './continuous-record-create-dialog/continuous-record-create-dialog.component';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';

@Component({
    selector: 'app-folder-continuous-record-widget',
    templateUrl: './folder-continuous-record-widget.component.html',
    styleUrl: './folder-continuous-record-widget.component.scss',
    providers: [FolderContinuousRecordWidgetStore],
    imports: [
        SafeHtmlPipe,
    ],
})
export class FolderContinuousRecordWidgetComponent {

    protected readonly store = inject(FolderContinuousRecordWidgetStore);
    protected readonly dialogService = inject(BaseDialogService);

    public folderId = input.required<number, string | number>({
        transform: (it) => Number(it),
    });

    constructor() {

        this.store.onSuccess(() => this.refresh(), 'createWork');
        
        effect(() => this.refresh());
    }

    public edit(): void {
        this.dialogService.open(
            ContinuousRecordCreateDialogComponent,
            {
                header: translate.instant('workData.continuousRecord.label'),
                styleClass: 'p-dialog-width-80',
                data: { item: this.store.lastRecord() },
                focusOnShow: false,
            },
        );
    }

    protected async refresh(): Promise<void> {
        const filter = FilterBuilder.filter({
            folderId: this.folderId(),
            workType: WorkTypeEnum.CONTINUOUS_RECORD,
            sort: { column: 'dateFrom', direction: 'DESC' },
            limit: 1,
        });

        await this.store.api.getWorks(filter, getWorkFrag);
    }

}
